import { shouldSpawnToday } from "./scheduling";
import { isTaskOverdue } from "./time";

export const isRepeatTask = (task) => {
  if (!task) return false;
  if (task.frequency === "repeat") return true;
  if (typeof task.repeat === "string") return true;
  if (task.repeat && typeof task.repeat.type === "string") return true;
  return typeof task.repeatType === "string";
};

export const getTaskLastResetMs = (value) => {
  if (!value) return 0;
  if (typeof value === "number") return value;
  if (typeof value.toMillis === "function") return value.toMillis();
  const parsed = new Date(value).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const shouldRepeatResetToday = (task, now, localMidnightUtcMs) => {
  if (!isRepeatTask(task)) return false;
  const rawStatus = task?.status || "open";
  if (rawStatus === "pending") return false;
  if (!shouldSpawnToday(task, now)) return false;
  return getTaskLastResetMs(task?.lastReset) < localMidnightUtcMs;
};

export const getEffectiveTaskStatus = (
  task,
  {
    autoFailActive = false,
    now = new Date(),
    graceMins = 0,
    localMidnightUtcMs = 0
  } = {}
) => {
  if (!task) return "open";
  const rawStatus = task.status || "open";

  if (autoFailActive && rawStatus === "open" && isTaskOverdue(task, now, graceMins)) {
    return "failed";
  }

  if (shouldRepeatResetToday(task, now, localMidnightUtcMs)) {
    return "open";
  }

  return rawStatus;
};
